import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _081265ec = () => interopDefault(import('../../../pages/agence-de-communication.vue' /* webpackChunkName: "pages/agence-de-communication" */))
const _999675e2 = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _06b7b198 = () => interopDefault(import('../../../pages/cgv.vue' /* webpackChunkName: "pages/cgv" */))
const _e64111b4 = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _69b506d3 = () => interopDefault(import('../../../pages/etudes-de-cas/index.vue' /* webpackChunkName: "pages/etudes-de-cas/index" */))
const _b1a05432 = () => interopDefault(import('../../../pages/generateur-signature.vue' /* webpackChunkName: "pages/generateur-signature" */))
const _32d79714 = () => interopDefault(import('../../../pages/lp-agence-com.vue' /* webpackChunkName: "pages/lp-agence-com" */))
const _2aa72a0e = () => interopDefault(import('../../../pages/lp2-agence-com.vue' /* webpackChunkName: "pages/lp2-agence-com" */))
const _79a8b8e6 = () => interopDefault(import('../../../pages/mentions-legales.vue' /* webpackChunkName: "pages/mentions-legales" */))
const _39371230 = () => interopDefault(import('../../../pages/recrutement.vue' /* webpackChunkName: "pages/recrutement" */))
const _5f4f3440 = () => interopDefault(import('../../../pages/remerciement.vue' /* webpackChunkName: "pages/remerciement" */))
const _bfa05f30 = () => interopDefault(import('../../../pages/blog/4-astuces-pour-cartonner-sur-les-reseaux.vue' /* webpackChunkName: "pages/blog/4-astuces-pour-cartonner-sur-les-reseaux" */))
const _14dd5632 = () => interopDefault(import('../../../pages/blog/4-raisons-pour-lesquelles-le-reputation-peut-contribuer-a-la-performance-de-votre-entreprise-2.vue' /* webpackChunkName: "pages/blog/4-raisons-pour-lesquelles-le-reputation-peut-contribuer-a-la-performance-de-votre-entreprise-2" */))
const _2d40cab2 = () => interopDefault(import('../../../pages/blog/agence-communication-comment-choisir-la-bonne-agence-de-communication.vue' /* webpackChunkName: "pages/blog/agence-communication-comment-choisir-la-bonne-agence-de-communication" */))
const _0961606a = () => interopDefault(import('../../../pages/blog/avantages-de-travailler-avec-une-agence-partenaire-google.vue' /* webpackChunkName: "pages/blog/avantages-de-travailler-avec-une-agence-partenaire-google" */))
const _1da64edc = () => interopDefault(import('../../../pages/blog/comment-bien-demarrer-et-communiquer-sur-linkedin.vue' /* webpackChunkName: "pages/blog/comment-bien-demarrer-et-communiquer-sur-linkedin" */))
const _11b2c6b7 = () => interopDefault(import('../../../pages/blog/comment-choisir-la-meilleure-agence-de-communication-digitale-en-2020.vue' /* webpackChunkName: "pages/blog/comment-choisir-la-meilleure-agence-de-communication-digitale-en-2020" */))
const _5724e33e = () => interopDefault(import('../../../pages/blog/comment-creer-une-strategie-marketing-efficace-sur-facebook.vue' /* webpackChunkName: "pages/blog/comment-creer-une-strategie-marketing-efficace-sur-facebook" */))
const _da6299aa = () => interopDefault(import('../../../pages/blog/comment-developper-une-strategie-de-contenu-efficace.vue' /* webpackChunkName: "pages/blog/comment-developper-une-strategie-de-contenu-efficace" */))
const _78228114 = () => interopDefault(import('../../../pages/blog/comment-faire-un-reel-instagram.vue' /* webpackChunkName: "pages/blog/comment-faire-un-reel-instagram" */))
const _504a5e26 = () => interopDefault(import('../../../pages/blog/comment-realiser-son-calendrier-editorial.vue' /* webpackChunkName: "pages/blog/comment-realiser-son-calendrier-editorial" */))
const _f1eb982a = () => interopDefault(import('../../../pages/blog/comment-reussir-la-refonte-de-votre-site-internet.vue' /* webpackChunkName: "pages/blog/comment-reussir-la-refonte-de-votre-site-internet" */))
const _9d615b22 = () => interopDefault(import('../../../pages/blog/conditions-fondamentaux-et-benefices-dune-bonne-landing-page.vue' /* webpackChunkName: "pages/blog/conditions-fondamentaux-et-benefices-dune-bonne-landing-page" */))
const _07e9a5e2 = () => interopDefault(import('../../../pages/blog/conseils-cartes-visite-efficaces-2.vue' /* webpackChunkName: "pages/blog/conseils-cartes-visite-efficaces-2" */))
const _b0eca034 = () => interopDefault(import('../../../pages/blog/creation-de-site-marchand-comment-faire-ses-premiers-pas.vue' /* webpackChunkName: "pages/blog/creation-de-site-marchand-comment-faire-ses-premiers-pas" */))
const _b3206ca6 = () => interopDefault(import('../../../pages/blog/interview-client-fabrice-jouaud-gerant-des-deboucheurs-de-limpossible.vue' /* webpackChunkName: "pages/blog/interview-client-fabrice-jouaud-gerant-des-deboucheurs-de-limpossible" */))
const _3caa8c34 = () => interopDefault(import('../../../pages/blog/nancomcy-fete-ses-6-ans.vue' /* webpackChunkName: "pages/blog/nancomcy-fete-ses-6-ans" */))
const _f3e4a63a = () => interopDefault(import('../../../pages/blog/nancomcy-quand-rentree-rime-avec-nouveautes.vue' /* webpackChunkName: "pages/blog/nancomcy-quand-rentree-rime-avec-nouveautes" */))
const _a9fdce74 = () => interopDefault(import('../../../pages/blog/notre-guide-pour-gerer-efficacement-vos-avis-clients.vue' /* webpackChunkName: "pages/blog/notre-guide-pour-gerer-efficacement-vos-avis-clients" */))
const _0ae4cf4d = () => interopDefault(import('../../../pages/blog/pourquoi-creer-votre-blog-dentreprise.vue' /* webpackChunkName: "pages/blog/pourquoi-creer-votre-blog-dentreprise" */))
const _4ad496f6 = () => interopDefault(import('../../../pages/blog/pourquoi-la-deuxieme-page-de-google-est-le-meilleur-endroit-pour-cacher-un-tresor.vue' /* webpackChunkName: "pages/blog/pourquoi-la-deuxieme-page-de-google-est-le-meilleur-endroit-pour-cacher-un-tresor" */))
const _724739d2 = () => interopDefault(import('../../../pages/blog/pourquoi-la-video-est-un-outil-de-communication-incontournable.vue' /* webpackChunkName: "pages/blog/pourquoi-la-video-est-un-outil-de-communication-incontournable" */))
const _20ee013c = () => interopDefault(import('../../../pages/blog/pourquoi-sommes-nous-si-dependants-aux-reseaux-sociaux.vue' /* webpackChunkName: "pages/blog/pourquoi-sommes-nous-si-dependants-aux-reseaux-sociaux" */))
const _1bf2c8b3 = () => interopDefault(import('../../../pages/blog/profiter-du-confinement-pour-se-transformer-nos-5-conseils.vue' /* webpackChunkName: "pages/blog/profiter-du-confinement-pour-se-transformer-nos-5-conseils" */))
const _ad2ec21c = () => interopDefault(import('../../../pages/blog/referencement-naturel-comment-cibler-vos-clients.vue' /* webpackChunkName: "pages/blog/referencement-naturel-comment-cibler-vos-clients" */))
const _20d7a26c = () => interopDefault(import('../../../pages/blog/retrospective-2021-les-actus-nancomcy-qui-ont-marque-l-annee.vue' /* webpackChunkName: "pages/blog/retrospective-2021-les-actus-nancomcy-qui-ont-marque-l-annee" */))
const _c086b526 = () => interopDefault(import('../../../pages/blog/reussir-son-logo-dentreprise.vue' /* webpackChunkName: "pages/blog/reussir-son-logo-dentreprise" */))
const _448ae476 = () => interopDefault(import('../../../pages/blog/solutions-digitales-et-ecrans-vitrine-5-strategies-infaillibles-pour-booster-la-visibilite-de-son-commerce.vue' /* webpackChunkName: "pages/blog/solutions-digitales-et-ecrans-vitrine-5-strategies-infaillibles-pour-booster-la-visibilite-de-son-commerce" */))
const _46cc1db2 = () => interopDefault(import('../../../pages/blog/tout-savoir-sur-google-ads-pour-les-entreprises-locales.vue' /* webpackChunkName: "pages/blog/tout-savoir-sur-google-ads-pour-les-entreprises-locales" */))
const _96d544be = () => interopDefault(import('../../../pages/blog/tpe-pme-les-10-outils-qui-vont-vous-changer-la-vie.vue' /* webpackChunkName: "pages/blog/tpe-pme-les-10-outils-qui-vont-vous-changer-la-vie" */))
const _ed5ceace = () => interopDefault(import('../../../pages/blog/trouver-les-bons-hashtags-mode-emploi.vue' /* webpackChunkName: "pages/blog/trouver-les-bons-hashtags-mode-emploi" */))
const _21c6640c = () => interopDefault(import('../../../pages/blog/une-agence-de-communication-a-360-comment-ca-marche.vue' /* webpackChunkName: "pages/blog/une-agence-de-communication-a-360-comment-ca-marche" */))
const _e2e37a8e = () => interopDefault(import('../../../pages/blog/une-agence-de-communication-a-quoi-bon.vue' /* webpackChunkName: "pages/blog/une-agence-de-communication-a-quoi-bon" */))
const _337ba97a = () => interopDefault(import('../../../pages/etudes-de-cas/fratelli-cucine.vue' /* webpackChunkName: "pages/etudes-de-cas/fratelli-cucine" */))
const _5600bd52 = () => interopDefault(import('../../../pages/etudes-de-cas/goddyns.vue' /* webpackChunkName: "pages/etudes-de-cas/goddyns" */))
const _416d90f0 = () => interopDefault(import('../../../pages/etudes-de-cas/islekter.vue' /* webpackChunkName: "pages/etudes-de-cas/islekter" */))
const _2f19bd92 = () => interopDefault(import('../../../pages/etudes-de-cas/nancy-open-air.vue' /* webpackChunkName: "pages/etudes-de-cas/nancy-open-air" */))
const _5835274d = () => interopDefault(import('../../../pages/etudes-de-cas/stella-compta.vue' /* webpackChunkName: "pages/etudes-de-cas/stella-compta" */))
const _76474286 = () => interopDefault(import('../../../pages/etudes-de-cas/velaine-immo.vue' /* webpackChunkName: "pages/etudes-de-cas/velaine-immo" */))
const _44fbc7a3 = () => interopDefault(import('../../../pages/prestations/accompagnement.vue' /* webpackChunkName: "pages/prestations/accompagnement" */))
const _75a5fb91 = () => interopDefault(import('../../../pages/prestations/identite-visuelle.vue' /* webpackChunkName: "pages/prestations/identite-visuelle" */))
const _3a08294e = () => interopDefault(import('../../../pages/prestations/motion-design.vue' /* webpackChunkName: "pages/prestations/motion-design" */))
const _94aeda7c = () => interopDefault(import('../../../pages/prestations/referencement.vue' /* webpackChunkName: "pages/prestations/referencement" */))
const _4792eaad = () => interopDefault(import('../../../pages/prestations/reseaux-sociaux.vue' /* webpackChunkName: "pages/prestations/reseaux-sociaux" */))
const _591267a0 = () => interopDefault(import('../../../pages/prestations/site-internet.vue' /* webpackChunkName: "pages/prestations/site-internet" */))
const _406fefd8 = () => interopDefault(import('../../../pages/prestations/video.vue' /* webpackChunkName: "pages/prestations/video" */))
const _2dfb1658 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/agence-de-communication/",
    component: _081265ec,
    pathToRegexpOptions: {"strict":true},
    name: "agency"
  }, {
    path: "/blog/",
    component: _999675e2,
    pathToRegexpOptions: {"strict":true},
    name: "blog"
  }, {
    path: "/cgv/",
    component: _06b7b198,
    pathToRegexpOptions: {"strict":true},
    name: "cgv"
  }, {
    path: "/contact/",
    component: _e64111b4,
    pathToRegexpOptions: {"strict":true},
    name: "contact"
  }, {
    path: "/etudes-de-cas/",
    component: _69b506d3,
    pathToRegexpOptions: {"strict":true},
    name: "projects"
  }, {
    path: "/generateur-signature/",
    component: _b1a05432,
    pathToRegexpOptions: {"strict":true},
    name: "generateur-signature"
  }, {
    path: "/lp-agence-com/",
    component: _32d79714,
    pathToRegexpOptions: {"strict":true},
    name: "lp-agence-com"
  }, {
    path: "/lp2-agence-com/",
    component: _2aa72a0e,
    pathToRegexpOptions: {"strict":true},
    name: "lp2-agence-com"
  }, {
    path: "/mentions-legales/",
    component: _79a8b8e6,
    pathToRegexpOptions: {"strict":true},
    name: "mentions"
  }, {
    path: "/recrutement/",
    component: _39371230,
    pathToRegexpOptions: {"strict":true},
    name: "jobs"
  }, {
    path: "/remerciement/",
    component: _5f4f3440,
    pathToRegexpOptions: {"strict":true},
    name: "remerciement"
  }, {
    path: "/blog/4-astuces-pour-cartonner-sur-les-reseaux/",
    component: _bfa05f30,
    pathToRegexpOptions: {"strict":true},
    name: "blog-4-astuces-pour-cartonner-sur-les-reseaux"
  }, {
    path: "/blog/4-raisons-pour-lesquelles-le-reputation-peut-contribuer-a-la-performance-de-votre-entreprise-2/",
    component: _14dd5632,
    pathToRegexpOptions: {"strict":true},
    name: "blog-4-raisons-pour-lesquelles-le-reputation-peut-contribuer-a-la-performance-de-votre-entreprise-2"
  }, {
    path: "/blog/agence-communication-comment-choisir-la-bonne-agence-de-communication/",
    component: _2d40cab2,
    pathToRegexpOptions: {"strict":true},
    name: "blog-agence-communication-comment-choisir-la-bonne-agence-de-communication"
  }, {
    path: "/blog/avantages-de-travailler-avec-une-agence-partenaire-google/",
    component: _0961606a,
    pathToRegexpOptions: {"strict":true},
    name: "blog-avantages-de-travailler-avec-une-agence-partenaire-google"
  }, {
    path: "/blog/comment-bien-demarrer-et-communiquer-sur-linkedin/",
    component: _1da64edc,
    pathToRegexpOptions: {"strict":true},
    name: "blog-comment-bien-demarrer-et-communiquer-sur-linkedin"
  }, {
    path: "/blog/comment-choisir-la-meilleure-agence-de-communication-digitale-en-2020/",
    component: _11b2c6b7,
    pathToRegexpOptions: {"strict":true},
    name: "blog-comment-choisir-la-meilleure-agence-de-communication-digitale-en-2020"
  }, {
    path: "/blog/comment-creer-une-strategie-marketing-efficace-sur-facebook/",
    component: _5724e33e,
    pathToRegexpOptions: {"strict":true},
    name: "blog-comment-creer-une-strategie-marketing-efficace-sur-facebook"
  }, {
    path: "/blog/comment-developper-une-strategie-de-contenu-efficace/",
    component: _da6299aa,
    pathToRegexpOptions: {"strict":true},
    name: "blog-comment-developper-une-strategie-de-contenu-efficace"
  }, {
    path: "/blog/comment-faire-un-reel-instagram/",
    component: _78228114,
    pathToRegexpOptions: {"strict":true},
    name: "blog-comment-faire-un-reel-instagram"
  }, {
    path: "/blog/comment-realiser-son-calendrier-editorial/",
    component: _504a5e26,
    pathToRegexpOptions: {"strict":true},
    name: "blog-comment-realiser-son-calendrier-editorial"
  }, {
    path: "/blog/comment-reussir-la-refonte-de-votre-site-internet/",
    component: _f1eb982a,
    pathToRegexpOptions: {"strict":true},
    name: "blog-comment-reussir-la-refonte-de-votre-site-internet"
  }, {
    path: "/blog/conditions-fondamentaux-et-benefices-dune-bonne-landing-page/",
    component: _9d615b22,
    pathToRegexpOptions: {"strict":true},
    name: "blog-conditions-fondamentaux-et-benefices-dune-bonne-landing-page"
  }, {
    path: "/blog/conseils-cartes-visite-efficaces-2/",
    component: _07e9a5e2,
    pathToRegexpOptions: {"strict":true},
    name: "blog-conseils-cartes-visite-efficaces-2"
  }, {
    path: "/blog/creation-de-site-marchand-comment-faire-ses-premiers-pas/",
    component: _b0eca034,
    pathToRegexpOptions: {"strict":true},
    name: "blog-creation-de-site-marchand-comment-faire-ses-premiers-pas"
  }, {
    path: "/blog/interview-client-fabrice-jouaud-gerant-des-deboucheurs-de-limpossible/",
    component: _b3206ca6,
    pathToRegexpOptions: {"strict":true},
    name: "blog-interview-client-fabrice-jouaud-gerant-des-deboucheurs-de-limpossible"
  }, {
    path: "/blog/nancomcy-fete-ses-6-ans/",
    component: _3caa8c34,
    pathToRegexpOptions: {"strict":true},
    name: "blog-nancomcy-fete-ses-6-ans"
  }, {
    path: "/blog/nancomcy-quand-rentree-rime-avec-nouveautes/",
    component: _f3e4a63a,
    pathToRegexpOptions: {"strict":true},
    name: "blog-nancomcy-quand-rentree-rime-avec-nouveautes"
  }, {
    path: "/blog/notre-guide-pour-gerer-efficacement-vos-avis-clients/",
    component: _a9fdce74,
    pathToRegexpOptions: {"strict":true},
    name: "blog-notre-guide-pour-gerer-efficacement-vos-avis-clients"
  }, {
    path: "/blog/pourquoi-creer-votre-blog-dentreprise/",
    component: _0ae4cf4d,
    pathToRegexpOptions: {"strict":true},
    name: "blog-pourquoi-creer-votre-blog-dentreprise"
  }, {
    path: "/blog/pourquoi-la-deuxieme-page-de-google-est-le-meilleur-endroit-pour-cacher-un-tresor/",
    component: _4ad496f6,
    pathToRegexpOptions: {"strict":true},
    name: "blog-pourquoi-la-deuxieme-page-de-google-est-le-meilleur-endroit-pour-cacher-un-tresor"
  }, {
    path: "/blog/pourquoi-la-video-est-un-outil-de-communication-incontournable/",
    component: _724739d2,
    pathToRegexpOptions: {"strict":true},
    name: "blog-pourquoi-la-video-est-un-outil-de-communication-incontournable"
  }, {
    path: "/blog/pourquoi-sommes-nous-si-dependants-aux-reseaux-sociaux/",
    component: _20ee013c,
    pathToRegexpOptions: {"strict":true},
    name: "blog-pourquoi-sommes-nous-si-dependants-aux-reseaux-sociaux"
  }, {
    path: "/blog/profiter-du-confinement-pour-se-transformer-nos-5-conseils/",
    component: _1bf2c8b3,
    pathToRegexpOptions: {"strict":true},
    name: "blog-profiter-du-confinement-pour-se-transformer-nos-5-conseils"
  }, {
    path: "/blog/referencement-naturel-comment-cibler-vos-clients/",
    component: _ad2ec21c,
    pathToRegexpOptions: {"strict":true},
    name: "blog-referencement-naturel-comment-cibler-vos-clients"
  }, {
    path: "/blog/retrospective-2021-les-actus-nancomcy-qui-ont-marque-l-annee/",
    component: _20d7a26c,
    pathToRegexpOptions: {"strict":true},
    name: "blog-retrospective-2021-les-actus-nancomcy-qui-ont-marque-l-annee"
  }, {
    path: "/blog/reussir-son-logo-dentreprise/",
    component: _c086b526,
    pathToRegexpOptions: {"strict":true},
    name: "blog-reussir-son-logo-dentreprise"
  }, {
    path: "/blog/solutions-digitales-et-ecrans-vitrine-5-strategies-infaillibles-pour-booster-la-visibilite-de-son-commerce/",
    component: _448ae476,
    pathToRegexpOptions: {"strict":true},
    name: "blog-solutions-digitales-et-ecrans-vitrine-5-strategies-infaillibles-pour-booster-la-visibilite-de-son-commerce"
  }, {
    path: "/blog/tout-savoir-sur-google-ads-pour-les-entreprises-locales/",
    component: _46cc1db2,
    pathToRegexpOptions: {"strict":true},
    name: "blog-tout-savoir-sur-google-ads-pour-les-entreprises-locales"
  }, {
    path: "/blog/tpe-pme-les-10-outils-qui-vont-vous-changer-la-vie/",
    component: _96d544be,
    pathToRegexpOptions: {"strict":true},
    name: "blog-tpe-pme-les-10-outils-qui-vont-vous-changer-la-vie"
  }, {
    path: "/blog/trouver-les-bons-hashtags-mode-emploi/",
    component: _ed5ceace,
    pathToRegexpOptions: {"strict":true},
    name: "blog-trouver-les-bons-hashtags-mode-emploi"
  }, {
    path: "/blog/une-agence-de-communication-a-360-comment-ca-marche/",
    component: _21c6640c,
    pathToRegexpOptions: {"strict":true},
    name: "blog-une-agence-de-communication-a-360-comment-ca-marche"
  }, {
    path: "/blog/une-agence-de-communication-a-quoi-bon/",
    component: _e2e37a8e,
    pathToRegexpOptions: {"strict":true},
    name: "blog-une-agence-de-communication-a-quoi-bon"
  }, {
    path: "/etudes-de-cas/fratelli-cucine/",
    component: _337ba97a,
    pathToRegexpOptions: {"strict":true},
    name: "fratelli-cucine"
  }, {
    path: "/etudes-de-cas/goddyns/",
    component: _5600bd52,
    pathToRegexpOptions: {"strict":true},
    name: "goddyns"
  }, {
    path: "/etudes-de-cas/islekter/",
    component: _416d90f0,
    pathToRegexpOptions: {"strict":true},
    name: "islekter"
  }, {
    path: "/etudes-de-cas/nancy-open-air/",
    component: _2f19bd92,
    pathToRegexpOptions: {"strict":true},
    name: "nancy-open-air"
  }, {
    path: "/etudes-de-cas/stella-compta/",
    component: _5835274d,
    pathToRegexpOptions: {"strict":true},
    name: "stella-compta"
  }, {
    path: "/etudes-de-cas/velaine-immo/",
    component: _76474286,
    pathToRegexpOptions: {"strict":true},
    name: "velaine-immo"
  }, {
    path: "/prestations/accompagnement/",
    component: _44fbc7a3,
    pathToRegexpOptions: {"strict":true},
    name: "strategy"
  }, {
    path: "/prestations/identite-visuelle/",
    component: _75a5fb91,
    pathToRegexpOptions: {"strict":true},
    name: "graphisme"
  }, {
    path: "/prestations/motion-design/",
    component: _3a08294e,
    pathToRegexpOptions: {"strict":true},
    name: "motion"
  }, {
    path: "/prestations/referencement/",
    component: _94aeda7c,
    pathToRegexpOptions: {"strict":true},
    name: "referencement"
  }, {
    path: "/prestations/reseaux-sociaux/",
    component: _4792eaad,
    pathToRegexpOptions: {"strict":true},
    name: "social"
  }, {
    path: "/prestations/site-internet/",
    component: _591267a0,
    pathToRegexpOptions: {"strict":true},
    name: "web"
  }, {
    path: "/prestations/video/",
    component: _406fefd8,
    pathToRegexpOptions: {"strict":true},
    name: "video"
  }, {
    path: "/",
    component: _2dfb1658,
    pathToRegexpOptions: {"strict":true},
    name: "home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
